import classNames from 'classnames';
import { AccessBadgeEntityType } from 'wb-reddit/app/common/utils';
import { Counter, Tooltip, translate } from '@aleph/shared-components';
import { Link } from 'react-router-dom';

const getAccessEntityName = (type?: string | null) => {
	if (type?.toUpperCase?.() === 'CLIENT') {
		return translate('re: access_entity.ad_account', { defaultValue: 'Ad Account' });
	}

	if (type?.toUpperCase?.() === 'AGENCYACCOUNT') {
		return translate('re: access_entity.advertiser', { defaultValue: 'Advertiser' });
	}

	return type;
};

const AccessBadge = ({
	accessEntities, label, className, labelClassName, href,
}: {
	accessEntities: AccessBadgeEntityType[],
	label?: string,
	className?: string,
	labelClassName?: string,
	href?: string,
}) => (
	<span className={classNames('flex gap-[12px]', className)}>
		<Tooltip
			placement="top"
			disabled={accessEntities.length === 0}
			content={
				accessEntities.map((accessEntity, idx) => (
					<div
						key={idx}
						className="flex items-center gap-[8px] whitespace-nowrap"
					>
						<div className="overflow-hidden overflow-ellipsis">{accessEntity?.name || accessEntity as string}</div>
						<div className="text-gray-600">{getAccessEntityName(accessEntity?.type)}</div>
					</div>
				))
			}
			showArrow
			size="large"
			className="z-modal"
		>
			<Counter
				className="relative"
				count={accessEntities.length ?? 0}
				showZero
			/>
		</Tooltip>
		{label && href && accessEntities.length
			? (
				<Link
					to={href}
					className={classNames(
						labelClassName,
						'cursor-pointer text-blue',
					)}
				>
					{label}
				</Link>
			)
			: (label && (
				<span
					className={classNames(
						labelClassName,
						'text-gray-600',
					)}
				>
					{label}
				</span>
			))
		}
	</span>);

export default AccessBadge;
